import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  return (
    <div className="p-5 flex items-center gap-2">
      <Button
        label="Add Invoice"
        className="p-2"
        onClick={() => navigate("/wholesaleaddinvoice")}
      />
      <Button
        label="Invoice List"
        className="p-2"
        onClick={() => navigate("/invoicelist")}
      />
      <Button
        label="Item List"
        className="p-2"
        onClick={() => navigate("/itemlist")}
      />
    </div>
  );
}
